import { InstantCompare } from '@airreading/common';
import { ReactNode } from 'react';
import { Temporal } from 'temporal-polyfill';

import { RequestSubstituteConfirmDialog } from '@/components/session/request-substitute-confirm-dialog';
import { SubstituteNotAvailableDialog } from '@/components/session/substitute-not-available-dialog';

interface RequestSessionSubstituteProps {
  sessionId: string;
  startInstant: Temporal.Instant;
  endInstant: Temporal.Instant;
  trigger: ReactNode;
  disabled?: boolean;
}

function isSessionPastOrAtStart(startInstant: Temporal.Instant): boolean {
  return InstantCompare(Temporal.Now.instant()).isAfterOrEqual(startInstant);
}

export const RequestSessionSubstitute = (props: RequestSessionSubstituteProps) => {
  const sessionHasStarted = isSessionPastOrAtStart(props.startInstant);

  if (sessionHasStarted) {
    return <SubstituteNotAvailableDialog trigger={props.trigger} disabled={props.disabled} />;
  }

  return <RequestSubstituteConfirmDialog {...props} />;
};
